import React from 'react'
import {Container} from 'react-bootstrap';
import withAuth from '../components/authHOC';
import Expensestable from '../components/ExpensesTable';

const LoansPage = () => {
    
  return (
       <Container fluid id='users-container'>
       
        <Expensestable></Expensestable>
    </Container>
  )
}
export default withAuth (LoansPage, ['admin', 'agent'])